import { render, staticRenderFns } from "./BookUserCategory.vue?vue&type=template&id=ac89c3be&scoped=true"
import script from "./BookUserCategory.vue?vue&type=script&lang=js"
export * from "./BookUserCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac89c3be",
  null
  
)

export default component.exports